/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useAppDispatch } from '../../app/hooks';
import { toNaiveISO } from '../../utils/date';
import { useTheme } from '../../utils/theme-context';
import { STAFF_ROLES } from '../../utils/constants/staff-roles';
import { tryToFetchQualityReport, tryToFetchTripTopics } from '../../store/admin/reports/reportsSlice';
import { tryToFetchAllJourneys } from '../../store/admin/trips/adminTripsSlice';
import { tryToFetchAllTeamMembers } from '../../store/brokers/partners/teams/teamsSlice';
import DateRangePopover from '../../features/admin/homepage/components/DateRange';
import SelectCheckbox from '../../shared/select-checkbox';
import Button from '../../shared/button';
import Modal from '../../shared/modal';
import Error from '../../shared/error';


const QualityReportModal = ({
    open,
    trips,
    trainManagers,
    staff,
    onClose,
}: {
    open: boolean;
    trips?: any;
    trainManagers?: any;
    staff?: any;
    onClose: () => void;
}) => {
    const { theme } = useTheme();
    const dispatch = useAppDispatch();
    const [reportError, setReportError] = useState<any>();
    // const [trips, setTrips] = useState<any>();
    // const [trainManagers, setTrainManagers] = useState<any>();
    // const [staff, setStaff] = useState<any>();
    const [topics, setTopics] = useState<any>();
    const [selectedTrip, setSelectedTrip] = useState<any>();
    const [selectedTrainManager, setSelectedTrainManager] = useState<any>();
    const [selectedStaff, setSelectedStaff] = useState<any>();
    const [selectedRole, setSelectedRole] = useState<any>();
    const [selectedTopic, setSelectedTopic] = useState<any>();
    const [showButton, setShowButton] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false)
    const [startDateRange, setStartDateRange] = useState<[Date, Date] | null>(null);
    const [endDateRange, setEndDateRange] = useState<[Date, Date] | null>(null);

    const onGettingDetails = async () => {
        try {
            // const trainManagerRes = await dispatch(tryToFetchAllTeamMembers({ role: 'train_manager' })).unwrap();
            // const formatTrainManagers = trainManagerRes && trainManagerRes?.length > 0 && trainManagerRes?.map((item: any) => {
            //     return {
            //         ...item || {},
            //         label: item?.name || item?.username,
            //         value: item?._id,
            //     }
            // })
            // setTrainManagers(formatTrainManagers)
            // const journeysRes = await dispatch(tryToFetchAllJourneys()).unwrap();
            // const formatJourneys = journeysRes?.elements && journeysRes?.elements?.length > 0 && journeysRes?.elements?.map((item: any) => {
            //     return {
            //         ...item || {},
            //         label: item?.journeyTitle,
            //         value: item?._id,
            //     }
            // })
            // setTrips(formatJourneys || undefined)
            // const staffRes = await dispatch(tryToFetchAllTeamMembers({ type: 'staff' })).unwrap();
            // const formatStaff = staffRes && staffRes?.length > 0 && staffRes?.map((item: any) => {
            //     return {
            //         ...item || {},
            //         label: item?.name || item?.username,
            //         value: item?._id,
            //     }
            // })
            // setStaff(formatStaff)
            const topicsRes = await dispatch(tryToFetchTripTopics()).unwrap();
            const formatTopics = topicsRes && topicsRes?.length > 0 && topicsRes?.map((item: any) => {
                return {
                    ...item || {},
                    label: item,
                    value: item,
                }
            })
            setTopics(formatTopics)
        } catch (err) {
            console.error(err)
        }
    }

    useEffect(() => {
        onGettingDetails()
    }, [])

    const onPrepareFilters = () => {
        let formatData: any
        if (selectedTrip && selectedTrip?.value !== 'all') {
            formatData = {
                ...formatData || {},
                data: {
                    ...formatData?.data || {},
                    itinerary: selectedTrip?.value
                }
            }
        }
        if (selectedTrainManager) {
            formatData = {
                ...formatData || {},
                data: {
                    ...formatData?.data || {},
                    trainManagerId: selectedTrainManager?.value
                }
            }
        }
        if (selectedTopic?.length > 0) {
            formatData = {
                ...formatData || {},
                data: {
                    ...formatData?.data || {},
                    topics: selectedTopic?.length > 0 && selectedTopic?.map((item: any) => item?.value)
                }
            }
        }
        if (selectedStaff) {
            formatData = {
                ...formatData || {},
                data: {
                    ...formatData?.data || {},
                    crewMemberId: selectedStaff?.value
                }
            }
        }
        if (selectedRole) {
            formatData = {
                ...formatData || {},
                data: {
                    ...formatData?.data || {},
                    crewMemberRole: selectedRole?.value
                }
            }
        }
        if (startDateRange) {
            formatData = {
                ...formatData || {},
                data: {
                    ...formatData?.data || {},
                    startDateMin: toNaiveISO(startDateRange?.[0]),
                    startDateMax: toNaiveISO(startDateRange?.[1])
                }
            }
        }
        if (endDateRange) {
            formatData = {
                ...formatData || {},
                data: {
                    ...formatData?.data || {},
                    endDateMin: toNaiveISO(endDateRange?.[0]),
                    endDateMax: toNaiveISO(endDateRange?.[1])
                }
            }
        }
        return formatData?.data
    }

    const onClickClearAll = () => {
        if (loading) return
        setStartDateRange(null)
        setEndDateRange(null)
        setSelectedStaff(undefined)
        setSelectedTrainManager(undefined)
        setSelectedTrip(undefined)
        setSelectedTopic(undefined)
        setSelectedRole(undefined)
        setReportError(undefined)
        setShowButton(false)
    }

    const onGettingData = async () => {
        try {
            setLoading(true)
            const formatData: any = onPrepareFilters() || {}
            setReportError(undefined)
            const res = await dispatch(tryToFetchQualityReport(formatData)).unwrap();
            if (res?.data) {
                const pdfUrl: string = res.data;
                const a = document.createElement('a');
                a.href = pdfUrl;
                a.target = '_blank';
                a.rel = 'noopener noreferrer';
                const filename = pdfUrl.split('/').pop()?.split('?')[0] || 'service-quality-report.pdf';
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                a.remove();
                onClickClearAll()
            }
            else {
                setReportError('Missing Report')
            }
        } catch (err) {
            setReportError(`${err}`)
        }
        setLoading(false)
    }

    const onChangeEndTripsDate = (value: any) => {
        setEndDateRange(value)
        setShowButton(true)
    }

    const onChangeStartTripsDate = (value: any) => {
        setStartDateRange(value)
        setShowButton(true)
    }

    const onChangeSelectedFilter = (value: any, type?: string) => {
        if (type) {
            switch (type) {
                case 'topic':
                    setSelectedTopic(value);
                    break;
                case 'trainManagerId':
                    setSelectedTrainManager(value)
                    break;
                case 'trip':
                    setSelectedTrip(value)
                    break;
                case 'staff':
                    setSelectedStaff(value)
                    break;
                case 'role':
                    setSelectedRole(value)
                    break;
            }
            setShowButton(true)
        }
    }

    return (
        <Modal
            open={open}
            title={'Guest Feedback Reports'}
            onClose={onClose}
            contentContainerStyle='!rounded-xl min-w-[95%] md:min-w-[90%] lg:min-w-[80%]'>
            <div className='p-2 max-w-[95vw] md:min-w-[70%] lg:min-w-[70%] min-h-[500px]'>
                <div className='bg-gray-100 dark:bg-gray-800 p-4 rounded-md shadow-md my-10'>
                    <div className='grid grid-cols-1 md:grid-cols-1 lg:grid-cols-4 gap-4'>
                        <div>
                            <label className='block mb-1 font-medium dark:text-white'>Itinerary</label>
                            <SelectCheckbox
                                placeholder='All Itineraries'
                                options={trips}
                                selectedOption={selectedTrip}
                                uniqueName='trip'
                                onChangeSelectedOption={onChangeSelectedFilter}
                            />
                        </div>
                        <div>
                            <label className='block mb-1 font-medium dark:text-white'>Train Manager</label>
                            <SelectCheckbox
                                placeholder='All Train Managers'
                                options={trainManagers}
                                selectedOption={selectedTrainManager}
                                uniqueName='trainManagerId'
                                onChangeSelectedOption={onChangeSelectedFilter}
                            />
                        </div>
                        <div>
                            <label className='block mb-1 font-medium dark:text-white'>Crew Member</label>
                            <SelectCheckbox
                                placeholder='All Crew Members'
                                options={staff}
                                selectedOption={selectedStaff}
                                uniqueName='staff'
                                onChangeSelectedOption={onChangeSelectedFilter}
                            />
                        </div>
                        <div>
                            <label className='block mb-1 font-medium dark:text-white'>Crew Member Role</label>
                            <SelectCheckbox
                                placeholder='Roles'
                                options={STAFF_ROLES}
                                selectedOption={selectedRole}
                                uniqueName='role'
                                onChangeSelectedOption={onChangeSelectedFilter}
                            />
                        </div>
                    </div>
                    <div className='grid grid-cols-1 md:grid-cols-1 lg:grid-cols-6 gap-4'>
                        <div className='lg:col-span-2'>
                            <DateRangePopover
                                label='Start Date Range'
                                value={startDateRange}
                                showTime={true}
                                onChange={onChangeStartTripsDate}
                            />
                        </div>
                        <div className='lg:col-span-2'>
                            <DateRangePopover
                                label='End Date Range'
                                value={endDateRange}
                                showTime={true}
                                onChange={onChangeEndTripsDate}
                            />
                        </div>
                        <div>
                            <label className='block mb-1 font-medium dark:text-white'>Topics</label>
                            <SelectCheckbox
                                placeholder='All Topics'
                                options={topics}
                                selectedOption={selectedTopic}
                                uniqueName='topic'
                                multiple={true}
                                onChangeSelectedOption={onChangeSelectedFilter}
                            />
                        </div>
                        <div className='flex flex-row justify-center items-center'>
                            <Button
                                label={'Reset'}
                                icon={<img src={theme === 'dark' ? '/assets/insights-tab/reset-white.svg' : '/assets/insights-tab/reset.svg'} className='object-contain w-[24px] mr-2' />}
                                className='btn-primary-rounded !rounded-full !bg-white dark:!bg-black !text-[#1E4380] dark:!text-white !px-4 flex flex-row items-center justify-center mt-4'
                                onClickButton={onClickClearAll}
                            />
                        </div>
                    </div>
                </div>
                {reportError &&
                    <div className='flex flex-row justify-center my-3'>
                        <Error text={reportError} />
                    </div>
                }
                <div className='flex flex-row justify-center items-center my-4'>
                    <Button
                        label={'Download Guest Feedback Report - Quality Analysis'}
                        className={`btn-primary-rounded-less ${(showButton && !loading) ? 'cursor-pointer' : 'opacity-50 cursor-not-allowed'}`}
                        onClickButton={() => (showButton && !loading) && onGettingData()}
                    />
                </div>
            </div>
        </Modal>
    );
};

export default QualityReportModal;